//https://colorbrewer2.org/#type=diverging&scheme=RdBu&n=9
//sequential diverging
export const rgbpalette = [
  [215 / 255, 48 / 255, 39 / 255],
  [244 / 255, 109 / 255, 67 / 255],
  [253 / 255, 174 / 255, 97 / 255],
  [254 / 255, 224 / 255, 144 / 255],
  [255 / 255, 255 / 255, 191 / 255],
  [224 / 255, 243 / 255, 248 / 255],
  [171 / 255, 217 / 255, 233 / 255],
  [116 / 255, 173 / 255, 209 / 255],
  [69 / 255, 117 / 255, 180 / 255],
  [63 / 255, 56 / 255, 134 / 255],
  [32 / 255, 40 / 255, 82 / 255],
  [32 / 255, 40 / 255, 82 / 255],
  [32 / 255, 40 / 255, 82 / 255],
  [32 / 255, 40 / 255, 82 / 255],
  [32 / 255, 40 / 255, 82 / 255],
];

export const hexpalette = [
  "#d73027",
  "#f46d43",
  "#fdae61",
  "#fee090",
  "#ffffbf",
  "#e0f3f8",
  "#abd9e9",
  "#74add1",
  "#4575b4",
  "#3f3886",
  "#202852",
];
